import { render, staticRenderFns } from "./AdminContracts.vue?vue&type=template&id=2e847594&"
import script from "./AdminContracts.vue?vue&type=script&lang=js&"
export * from "./AdminContracts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports